import TennisTable from "./TennisTable";

export const firstTennisSection = [
  {
    name: "Row 1",
    left: [],
    right: [
      { column1: "Overall Size", column2: "60ft x 120ft" },
      { column1: "Total Area", column2: "7,200 sq.ft./800 sq.yds" },
      { column1: "Playing Area", column2: "2,808 sq.ft./312 sq.yds" },
      { column1: "Outside Court Area", column2: "4,392 sq.ft./488 sq.yds" },
    ],
  },
];

export const secondTennisSection = [
  {
    name: "Row 2",
    left: ["Acrylic Resurfacer", "Acrylic Resurfacer With Sand"],
    right: [
      { column1: "One Coat", column2: "60 Gallons" },
      { column1: "One Coat", column2: "90 Gallons" },
    ],
  },
];

export const thirdTennisSection = [
  {
    name: "Row 3",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "35 Gallons" },
      { column1: "Two Coats", column2: "45 Gallons" },
      { column1: "Two Coats", column2: "75 Gallons" },
    ],
  },
];

export const forthTennisSection = [
  {
    name: "Row 4",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "50 Gallons" },
      { column1: "Two Coats", column2: "70 Gallons" },
      { column1: "Two Coats", column2: "120 Gallons" },
    ],
  },
];

export const fifthTennisSection = [
  {
    name: "Row 5",
    left: ["CushionMaster II (Coarse Rubber)", "CushionMaster I (Fine Rubber)"],
    right: [
      { column1: "Three Coats", column2: "360 Gallons" },
      { column1: "Two Coats", column2: "160 Gallons" },
    ],
  },
];

export const sixthTennisSection = [
  {
    name: "Row 6",
    left: ["Stripe Rite", "White Line Paint"],
    right: [
      { column1: "One Coat", column2: "1 Gallons" },
      { column1: "One Coat", column2: "1 Gallons" },
    ],
  },
];

export const sevenTennisSection = [
  {
    name: "Row 7",
    left: ["Standard Size Roll"],
    right: [{ column1: "8 Rolls" }],
  },
];

const TennisSingleCourt = () => {
  return (
    <>
      <TennisTable rows={firstTennisSection} hidden={true} />
      <TennisTable
        rows={secondTennisSection}
        leftCol={"Total Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={thirdTennisSection}
        leftCol={"Inside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={forthTennisSection}
        leftCol={"Outside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={fifthTennisSection}
        leftCol={"ProCushion LAYERS"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sixthTennisSection}
        leftCol={"STRIPING"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sevenTennisSection}
        leftCol={"MASKING TAPE"}
        middleCol={"Rolls Needed"}
      />
    </>
  );
};

export default TennisSingleCourt;
